import { Grid, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import * as Constant from 'common/Constant';
import moment from 'moment-timezone';
import { Controller, useFormContext } from 'react-hook-form';
import * as ValidationUtil from 'utils/ValidationUtil';

const DivisionDetail = () => {

  const { control, getValues, trigger } = useFormContext();

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={6}>
          <Controller
            rules={{
              required: Constant.ERROR_MSG_REQUIRED_FIELD
            }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                id="input-name"
                fullWidth
                {...field}
                required
                error={error}
                helperText={error ? error.message : null}
                label="Name"
              />
            )}
            name="name"
            control={control}
          />
        </Grid>
        <Grid item xs={6}>
          <Controller
            name="divisionNumber"
            rules={{ required: Constant.ERROR_MSG_REQUIRED_FIELD }}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                fullWidth
                {...field}
                required
                multiline
                error={error}
                helperText={error ? error.message : null}
                label="Division Number"
              />
            )}
          />
        </Grid>
        <Grid item xs={6}>
          <Controller
            rules={{
              validate: (value) => {
                return ValidationUtil.VALIDATE_START_END_DATE(
                  getValues('startDate'),
                  getValues('endDate')
                );
              }
            }}
            render={({ field, fieldState: { error } }) => (
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  {...field}
                  inputFormat={Constant.FORMAT_DATE}
                  label="Start Date"
                  id="input-startDate"
                  value={getValues('startDate') ? moment.utc(getValues('startDate')) : null}
                  onChange={(date) => {
                    field.onChange(date);
                    trigger('startDate');
                  }}
                  onBlur={field.onBlur}
                  slotProps={{
                    textField: {
                      error: !!error,
                      helperText: error?.message ?? null,
                      onBlur: field.onBlur
                    }
                  }}
                />
              </LocalizationProvider>
            )}
            name="startDate"
            control={control}
          />
        </Grid>
        <Grid item xs={6}>
          <Controller
            rules={{
              validate: (value) => {
                return ValidationUtil.VALIDATE_START_END_DATE(
                  getValues('startDate'),
                  getValues('endDate')
                );
              }
            }}
            render={({ field, fieldState: { error } }) => (
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  {...field}
                  inputFormat={Constant.FORMAT_DATE}
                  label="End Date"
                  id="input-endDate"
                  value={getValues('endDate') ? moment.utc(getValues('endDate')) : null}
                  onChange={(date) => {
                    field.onChange(date);
                    trigger('endDate');
                  }}
                  onBlur={field.onBlur}
                  slotProps={{
                    textField: {
                      error: !!error,
                      helperText: error?.message ?? null,
                      onBlur: field.onBlur
                    }
                  }}
                />
              </LocalizationProvider>
            )}
            name="endDate"
            control={control}
          />
        </Grid>
      </Grid>
    </>
  );
};
export default DivisionDetail;
